import React, { useEffect, useState } from "react"
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../../services/AuthService";
import Swal from "sweetalert2";
import { myroutes } from "../../routes/webroute";
import { useDispatch, useSelector } from "react-redux";
import { logoutRequest } from "../../backend/auth/logout";
import { resetAuthData } from "../../app/providers/authSlice";
import { MDBIcon } from 'mdb-react-ui-kit';
import { resetCart } from "../../app/providers/panierSlice";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';



//import { authCheck } from "../../services/http";



export default function TopBar() {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const handleShow = () => setShow(true);

    const [isLogin, setIsLogin] = useState(false);

    const auth = useSelector(state => state.auth)



    let navigate = useNavigate();

     const dispatch = useDispatch()

    //dispatch(checkAuthenticate()) 
    // se déconnecter
	const handleLogout = () => {    
		logoutRequest(auth.token);
		dispatch(resetAuthData());
        dispatch(resetCart());
        navigate(myroutes.login);
        Swal.fire({
            icon: "success",
                    title: 'Vous vous êtes déconnectée avec succès',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    background: "green",
                    color: "white",
                    iconColor: "white"
          });
	}

    useEffect(() => {
        
    }, []);


    return (
        <React.Fragment>
            <div className="container-fluid px-5 d-none d-lg-block " style={{backgroundColor:"#0A1F3D"}}>
                <div className="row gx-0">
                    <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0 mt-2 mb-2">
                        <div className="d-inline-flex align-items-center" style={{ height: "45px" }}>
                            <small className="me-3 text-light"><MDBIcon fas icon="mobile-alt me-2"  />+229 69 61 99 99</small>
                            <small className="text-light"><i className="fa fa-envelope-open me-2"></i>sales@dgbook.africa</small>
                        </div>
                    </div>
                    <div className="col-lg text-center text-lg-end mt-2 mb-2 mr-4">

                        {auth.isAuthenticate ? 
                            ( 
                            <>
                         <div className="d-flex align-items-center"> {/* Conteneur parent avec alignement en ligne */}

                             {auth.roles.includes("USER") && auth.roles.includes("ADMIN") ? (
                                // Si l'utilisateur a les deux rôles ("USER" et "ADMIN")
                                <>
                                <DropdownButton variant="outline-warning" className="bouton me-3" style={{zIndex: 999999}} id="dropdown-basic-button" title="Mon compte">
                                <Dropdown.Item href={myroutes.dashboard} className="text-dark" ><i className="fa fa-th-large me-2"></i>Tableau de bord</Dropdown.Item>
                                <Dropdown.Item href={myroutes.moncompte}><i className="fa fa-th-large me-2"></i>Mon compte utilisateur</Dropdown.Item>
                                </DropdownButton>
                                    
                                </>
                            ) : auth.roles.includes("USER") ? (

                                // Si l'utilisateur a uniquement le rôle "USER"
                                <Link to={myroutes.moncompte}>
                                    <Button variant="outline-warning" className="bouton me-3">
                                        <i className="fa fa-th-large me-2"></i>Mon compte
                                    </Button>
                                </Link>
                            ) : (
                                // Si l'utilisateur a uniquement le rôle "ADMIN" 
                                <Link to={myroutes.dashboard}>
                                    <Button variant="outline-warning" className="bouton me-3">
                                        <i className="fa fa-th-large me-2"></i>Tableau de bord
                                    </Button>
                                </Link>
                            )}
                                <Button
                                    variant="warning"
                                    onClick={handleLogout}
                                >
                                    <i className="fa fa-stop me-2"></i>Se déconnecter
                                </Button>
                                </div>
                            </>
                        ) : (
                            <>
                                <Button
                                    variant="outline-warning"
                                    className="bouton me-3"
                                    onClick={handleShow}
                                >
                                    <i className="fa fa-user-plus me-2"></i>S'inscrire
                                </Button>
                                <Link to={myroutes.login}><Button variant="warning">
                                    <i className="fa fa-lock me-2"></i>Se connecter</Button></Link>
                                </>
                        )}

                        <Modal show={show} onHide={handleClose} centered className="custom-modal">

                            <Modal.Header closeButton>

                                <Modal.Title className="mx-auto me-3"> Type d'utilisateur</Modal.Title>

                            </Modal.Header>

                            <Modal.Body>
                                <Container>

                                    <Row>
                                        <Col xs={8} md={6}>
                                            <Button href={myroutes.register} variant="primary" style={{ padding: "22px", borderRadius: "4px" }}>Je suis un particulier</Button>{' '}
                                        </Col>
                                        <Col xs={8} md={6}>
                                            <Button href={myroutes.register_entreprise} variant="warning" style={{ padding: "22px", borderRadius: "4px" }}>Je suis une entreprise</Button>{' '}
                                        </Col>

                                    </Row>
                                </Container>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="dark" onClick={handleClose} className="mx-auto">
                                    Fermer
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        {/**
                <div className="d-inline-flex align-items-center" style={{height: "45px" }}>
                    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-twitter fw-normal"></i></a>
                    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-facebook-f fw-normal"></i></a>
                    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-linkedin-in fw-normal"></i></a>
                    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-instagram fw-normal"></i></a>
                    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle" href=""><i className="fab fa-youtube fw-normal"></i></a>
                </div>
                 */}
                    </div>


                </div>
            </div>

        </React.Fragment>
    )
}